export type TrendExportState = {
    loading: boolean;
    success: boolean;
    url: string;
};

export const initialTrendExport: TrendExportState = {
    loading: false,
    success: false,
    url: '',
};
